<template>
  <div class="service-process">
    <div
      class="swiper-wrapper"
      v-loading="advantageSwiperLoading"
    >
      <swiper
        v-if="bannerArray.length > 0"
        :options="swiperOptionTop"
        class="gallery-top"
        ref="swiperTop"
      >
        <swiper-slide
          class="slide-1"
          v-bind:style="{ backgroundImage: 'url('+'\'' + item.path +'\'' + ')' }"
          v-for="(item, index) in bannerArray"
          :key="index"
        >
        </swiper-slide>
      </swiper>
    </div>
    <div class="data-wrapper">
      <p class="data-title">年会服务流程</p>
      <div class="data-items">
        <div class="data-item" v-for="item in processArray" :key="item.id">
          <span>{{item.title}}</span>
          <p>{{item.description}}</p>
        </div>
        <div class="data-item button-item">
          <button @click="showCustomForm()">免费咨询定制</button>
        </div>
      </div>
            <!-- <div class="data-items">
        <div class="data-item">
          <span>01提交需求</span>
          <p>在线填写年会基本需求，如人数、天数、年会类型等、点击提交。</p>
        </div>
        <div class="data-item">
          <span>02需求沟通</span>
          <p>
            15分钟内年会顾问1对1专人服务，沟通细节，以确保能全面了解客户的活动需求以及希望呈现的活动效果。
          </p>
        </div>
        <div class="data-item">
          <span>03方案策划</span>
          <p>
            根据客户的需求，策划师提供符合客户需求的年会产品和年会策划方案。
          </p>
        </div>
        <div class="data-item">
          <span>04方案完善</span>
          <p>
            根据客户的反馈细化改善方案内容，最后制作成可落地执行的年会方案。
          </p>
        </div>
        <div class="data-item">
          <span>05项目执行</span>
          <p>
            按照活动进度表推进整个活动的执行，期间保持与客户的紧密沟通，以确保活动顺利举办。
          </p>
        </div>
        <div class="data-item button-item">
          <button @click="showCustomForm()">免费咨询定制</button>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { handlePicPlusPre} from "@/util/util.js";
export default {
  name: "adDetails",
  components: {},
  props: {},
  data() {
    return {
      id: null,
      message: {},
      bannerArray: [
      ],
      processArray:[],
      swiperOptionTop: {
        autoplay: {
          delay: 3000, // 自动切换的时间间隔，单位ms
          disableOnInteraction: false, // 用户操作swiper之后，是否禁止autoplay。默认为true：停止
          reverseDirection: false, // 关键代码，开启反向自动轮播
        },
        // autoplay:3000,
        loop: true,
        slidesPerview: "auto",
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        advantageSwiperLoading: false,
      },
      advantageSwiperLoading: false,
    };
  },
  watch: {},
  computed: {
    // 获取站点城市id
    getLocationSiteCityId() {
      return this.$store.state.locationSiteCity?this.$store.state.locationSiteCity:5;
    },
  },
  methods: {
    handlePicPlusPre,
    showCustomForm(){
      this.$store.commit("saveAnnualMeetingCustomState", true); 
    },
    // 获取头部广告位置
    getBanner(positionId){
      console.log("getAdPosition-Start-year")
      const params = {
        positionId:positionId,
        cityId:this.getLocationSiteCityId
      }
      axios
        .get(`/api/adm/list`, {
          params
        })
        .then((res) => {
          console.log(res)
          if(res.data &&res.data.code == 200){
              this.bannerArray = res.data.adList;
            if(this.bannerArray){
              this.bannerArray.forEach(banner=>{
                banner.path =  handlePicPlusPre(banner.path);
              })
            }
          }
        })
    },
    // 获取年会流程广告位置
    getProcessBanner(){
      const params = {
        positionId:22,
        // cityId:this.getLocationSiteCityId
      }
      axios
        .get(`/api/adm/list`, {
          params
        })
        .then((res) => {
          console.log(res)
          if(res.data &&res.data.code == 200){
              this.processArray = res.data.adList;
            if(this.processArray){
              this.processArray.forEach(process=>{
                process.path =  handlePicPlusPre(process.path);
              })
            }
          }
        })
    },    
  },
  created() {
    this.getBanner(7);
    this.getProcessBanner();
  },
  mounted() {},
};
</script>
<style scoped>
.service-process {
  position: relative;
}
.service-process .gallery-top {
  height: 100% !important;
  width: 100%;
}
.service-process .gallery-top .slide-1 {
  background-position: center center;
  /* background-size: 100% 100%; */
  background-size: cover;
  height: 100%;
  background-repeat: no-repeat;

  position: relative;
}
.service-process .gallery-top .slide-1 a {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
}

.service-process .swiper-wrapper {
  position: relative;
  height: 540px;
  background: #000;
}
.service-process .swiper-wrapper >>> .swiper-pagination-bullet {
  background: #e4e4e4 !important;
}
.service-process .swiper-wrapper >>> .swiper-pagination-bullet-active {
  background: #000000 !important;
}
.service-process .swiper-pagination >>> span {
  width: 12px !important;
  height: 12px !important;
}
.service-process .data-wrapper {
  background-image: linear-gradient(
    -89deg,
    rgba(240, 109, 44, 0),
    rgba(253, 75, 68, 0.93) 42%,
    #fe4846
  );
  position: absolute;
  right: 0;
  top: 0px;
  /* top:-340px; */
  height: 540px;
  z-index: 1000;
  width: 100%;
}
.service-process .data-wrapper .data-title {
  font-size: 38px;
  color: #ffebbf;
  position: absolute;
  left: 275px;
  top: 75px;
  font-weight: 700;
}
.service-process .data-wrapper .data-items {
    flex-direction: row;
    flex-wrap: wrap;
    display: flex;
    position: absolute;
    left: 275px;
    top: 150px;
    width: 900px;
}
.service-process .data-wrapper .data-item {
    width: 170px;
    margin-right: 100px;
    margin-bottom: 30px;
    text-align: left;
}
.service-process .data-wrapper .data-item span{
    font-size: 20px;
    color: #ffebbf;
    font-weight: 700;
}
.service-process .data-wrapper .data-item p{
    margin-top: 20px;
    font-size: 14px;
    color: #ffebbf;
}
.service-process .data-wrapper .data-item button{
    outline: none;
    background: none;
    border: none;
    cursor: pointer;
    position: absolute;
    width: 156px;
    height: 52px;
    font-weight: 700;
    background: #ffebbf;
    border-radius: 6px;
    font-size: 16px;
    color: #9f6548;
}
p {
  text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/components/annualMeeting/serviceProcess.vue